module.exports = __webpack_public_path__ + "static/media/ic-no-deals.e82847c1.svg";